<script setup lang="ts">
import TechnoFrame from "@/components/Common/TechnoFrame.vue";
import SelectedBonusesDisplay from "@/components/RegistrationPage/MobileVersion/SelectedBonusesDisplay.vue";
import PaymentInfo from "@/components/RegistrationPage/Payment/PaymentInfo.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

export default defineComponent({
    name: 'SelectedBonuses',

    data() {
        return {
            state: store.state,
        }
    },

    computed: {
        selectedPass(): PassProperties | null
        {
            return this.state.selectedPass
        },
    },

    watch: {
        selectedPass: {
            handler(): void
            {
                setTimeout(() => {
                    const el: HTMLDivElement = this.$refs.selectedBonuses as HTMLDivElement
                    el.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    })
                }, 100)
            },
        },
    },
})
</script>

<template>
    <div ref="selectedBonuses">
        <div class="panel d-flex flex-column justify-content-center align-items-center" v-if="selectedPass">
            <PaymentInfo/>

            <div class="wrapper" v-if="state.canPurchase">
                <TechnoFrame :offset="8" :size-modifier="0.4"/>

                <div class="content">
                    <SelectedBonusesDisplay v-if="store.state.canPurchase"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.panel {
    gap: 45px;
}

.wrapper {
    position: relative;
    //background: black;
    //box-shadow: 0 0 15px 3px black;
    border-radius: 10px;
    width: fit-content;
    color: white;
    text-shadow: 2px 2px 5px black;
    background: rgba(0, 0, 0, 0.8);
    //margin-bottom: 100px;
    box-shadow: 0 0 25px 5px black;

    .content {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
    }
}
</style>
